<template>
    <tasks />
</template>

<script>
    import Tasks from '../../components/Tasks'

    export default {
        components: {
            Tasks
        }
    }
</script>
